<template>
  <div class="box" v-if="info || Region">
    <FansText :str="fansRegion"></FansText>
    <div class="city_box">
      <div style="text-align: center">
        <div id="city_1"></div>
        <span class="city_name">{{ city ? city[0].name : '暂无数据' }}</span>
      </div>
      <div style="text-align: center">
        <div id="city_2"></div>
        <span class="city_name">{{ city ? city[1].name : '暂无数据' }}</span>
      </div>
      <div style="text-align: center">
        <div id="city_3"></div>
        <span class="city_name">{{ city ? city[2].name : '暂无数据'}}</span>
      </div>
    </div>
    <div class="map_box">
      <div id="map"></div>
      <div class="ranking">
        <p>粉丝数TOP5省份</p>
        <div v-for="(item, index) in RegionName">
          <div class="fans-shen">
            <div
              class="som-box"
              :style="`background-color: ${color[index]}`"
            ></div>
            <span>TOP{{ index + 1 }}：{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="chart">
    <none-data :height="3.5" />
  </div>
</template>

<script>
import FansText from "@/components/FansText.vue";
import china from "./china";
export default {
  props: {
    info: { type: Object },
    Region: { type: Object },
  },
  components: { FansText },
  data() {
    return {
      color: ["#298CF4", "#54A0F6", "#7AB5F9", "#9FC9FB", "#C3DFFC"],
    };
  },
  computed: {
    fansRegion() {
      if (this.info) {
        const obj = this.info;
        if (obj && Array.isArray(obj)) return [];
        const topList = Object.entries(obj)
          .map(([name, value]) => ({ name, value: Number(value || 0) }))
          .sort((a, b) => b.value - a.value)
          .slice()
          .splice(0, 1); //排序取前1
        const ageRange = topList[0].name;
        return `${ageRange}地区的粉丝居多，在${ageRange}的粉丝群体中具有优势`;
      } else {
        return `${this.RegionName[0].name}的粉丝居多，在${this.RegionName[0].name}的粉丝群体中具有优势`;
      }
    },
    city() {
      if (this.info) {
        const obj = this.info;
        if (obj && Array.isArray(obj)) return [];
        const topList = Object.entries(obj)
          .map(([name, value]) => ({ name:name ==='unknown' ? '未知' : name, value: Number(value || 0) }))
          .sort((a, b) => b.value - a.value)
          .slice()
          .splice(0, 3)
          .map(item => {
            if(item.name.split('').length >= 6) {
              item.name = item.name.split('').splice(0, 4).toString().replace(/,/g,'') + '...'//长度大于6 就转为省略号
            }
            return item
          }) //排序取前3
        return topList;
      }
    },
    RegionName() {
      if (this.Region) {
        const Region = this.Region;
        if (Region && Array.isArray(Region)) return [];
        const topList = Object.entries(Region)
          .map(([name, value]) => ({ name:name ==='unknown' ? '未知' : name, value: Number(value || 0) }))
          .sort((a, b) => b.value - a.value)
          .slice()
          .splice(0, 5); //排序取前5
        return topList.map((item, index) => {
          return {
            name: item.name,
            selected: false,
            itemStyle: {
              emphasis: {
                borderWidth: 1,
                borderColor: "#fff",
                areaColor: "#2E96FF",
              },
              normal: {
                borderWidth: 1,
                borderColor: "#fff",
                areaColor: this.color[index],
              },
            },
          };
        });
      }
    },
  },
  methods: {
    // 字体适配
    FontChart(res) {
      //获取到屏幕的宽度
      var clientWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (!clientWidth) return; //报错拦截：
      let fontSize = 10 * (clientWidth / 1920);
      return res * fontSize;
    },
    drawChart() {
      const arr = [
        { city: "city_1", index: 0 },
        { city: "city_2", index: 1 },
        { city: "city_3", index: 2 },
      ];
      const text = this.city ? false : '0'
      const color = ["#ed5d2a", "#f1c757", "#418aec"];
      arr.forEach((item) => {
        echarts.init(document.getElementById(item.city)).setOption({
          backgroundColor: "#fff",
          title: {
            text: `${text ?  text  : (this.city[item.index].value * 100).toFixed(2)}%`,
            left: "center",
            top: "center",
            itemGap: 0,
            textStyle: {
              color: "#000",
              fontSize: this.FontChart(6),
              fontWeight: 400,
            },
          },
          angleAxis: {
            max: 100,
            // 隐藏刻度线
            show: false,
          },
          radiusAxis: {
            type: "category",
            show: true,
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
          polar: {
            radius: "170%", //图形大小
          },
          series: [
            {
              type: "bar",
              data: ["65"],
              showBackground: true,
              roundCap: true,
              backgroundStyle: {
                color: "#e9e9e9",
              },
              coordinateSystem: "polar",
              barWidth: this.FontChart(3),
              itemStyle: {
                normal: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: color[item.index],
                      },
                      {
                        offset: 1,
                        color: color[item.index],
                      },
                    ],
                    global: false,
                  },
                },
              },
            },
          ],
        });
      });
    },
    renderMap() {
      echarts.registerMap("china", china);
      echarts.init(document.getElementById("map")).setOption({
        tooltip: {
          trigger: "item",
          textStyle: {
            fontSize: this.FontChart(4), // 字体大小
          },
          formatter: (val) => {
            return val.name;
          },
        },
        series: [
          {
            name: "中国",
            type: "map",
            mapType: "china",
            selectedMode: false,
            label: {
              normal: {
                show: false, //显示省份标签
                textStyle: {
                  color: "#fbfdfe",
                }, //省份标签字体颜色
              },
              emphasis: {
                //对应的鼠标悬浮效果
                show: true,
                textStyle: {
                  color: "#fff",
                  fontSize: this.FontChart(4),
                },
              },
            },
            itemStyle: {
              normal: {
                borderWidth: 1,
                borderColor: "#87CEEB",
                areaColor: "#fbffff",
              },
              emphasis: {
                borderWidth: 1,
                borderColor: "#fff",
                areaColor: "#2E96FF",
              },
            },
            data: this.RegionName,
          },
        ],
      });
    },
  },
  mounted() {
   if((this.info || this.Region)) {
        this.drawChart();
        this.renderMap();
    }
  },
};
</script>

<style scoped lang="less">

.chart{
  width: 100%;
  height: 335px;
  justify-content: center;
  align-items: center;
  display: flex;
}


#city_1,
#city_2,
#city_3 {
  width: 68px;
  height: 68px;
  margin-bottom: 8px;
}

#map {
  width: 253px;
  height: 176px;
}
.city_box {
  margin-top: 16px;
  display: flex;
  justify-content: space-around;
  .city_name {
    font-size: 14px;
    color: #8e9aae;
  }
}
.map_box {
  display: flex;
  align-items: flex-end;
}
.ranking {
  p {
    font-size: 14p;
    color: #696d75;
    margin-bottom: 10px;
  }
  .fans-shen {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    .som-box {
      width: 8px;
      height: 8px;
      border-radius: 4px;
      margin-right: 5px;
    }
    span {
      font-size: 12px;
      color: #696d75;
    }
  }
}
</style>
